import { serverTimestamp } from "firebase/firestore";

export const memberMembershipToFirestore = (data, user) => {
    // eslint-disable-next-line no-unused-vars
    const { id, createdAt, createdBy, updatedAt, updatedBy, ...firestoreData } = data;
    
    const now = serverTimestamp();
    const currUser = user ? { uid: user.uid, name: user.name || user.email } : null;

    let payload;
    if (!data.id) {
        payload = {
            ...firestoreData,
            createdAt: now,
            createdBy: currUser,
            updatedAt: now,
            updatedBy: currUser,
        };
    } else {
        payload = {
            ...firestoreData,
            updatedAt: now,
            updatedBy: currUser,
        };
    }

    Object.keys(payload).forEach(key => payload[key] === undefined && delete payload[key]);
    return payload;
};

export const memberMembershipFromFirestore = (doc) => {
    const data = doc.data();
    return {
        id: doc.id,
        ...data,
        createdAt: data.createdAt?.toDate() || null,
        updatedAt: data.updatedAt?.toDate() || null,
    };
};
